import EmployeeSelect from '@/components/Form/Shared/EmployeeSelect'
import Paper from '@/components/Paper'
import { useForm } from 'react-hook-form'
import KPIManagement from '../KPIManagement'
import { Typogaphy } from 'vnetwork-ui'

const KPIEmployees = () => {
    const { control, watch } = useForm({
        defaultValues: {
            employeeID: null,
        },
    })
    return (
        <Paper>
            <Typogaphy className="text-primary font-medium">
                KPI Management
            </Typogaphy>
            <div className="mt-4">
                <EmployeeSelect control={control} name="employeeID" />
            </div>
            {watch('employeeID') && (
                <KPIManagement employeeID={watch('employeeID') || 0} />
            )}
        </Paper>
    )
}

export default KPIEmployees
